
import { defineComponent } from 'vue';
import Ripple from '../directives/ripple';
import Touch from '../directives/touch';

const keyCodes = {
	left: 37,
	right: 39
};

export default defineComponent({
	name: 'HokSwitch',
	directives: {
		Touch,
		Ripple
	},
	data() {
		return {
			isFocused: false,
			internalValue: this.value
		};
	},
	computed: {
		color() {
			switch (this.styling) {
				case 'main':
					return 'bg-color-main';
				case 'business':
				default:
					return 'bg-color-main-business';
			}
		},
		isActive() {
			return this.internalValue;
		}
	},
	created() {
		if (this.id === 'hokswitch') {
			console.warn('HokSwitch without explicit id', this);
		}
	},
	methods: {
		onSwipeLeft() {
			if (this.isActive) {
				this.onChange();
			}
		},
		onSwipeRight() {
			if (!this.isActive) {
				this.onChange();
			}
		},
		onChange() {
			if (!this.disabled) {
				if (!this.reactive) {
					this.internalValue = !this.internalValue;
				}
				this.$emit('input', this.internalValue);
			}
		},
		onFocus() {
			this.isFocused = true;
		},
		onBlur(e) {
			this.isFocused = false;
			this.$emit('blur', e);
		},
		onKeydown(e) {
			if (
				(e.keyCode === keyCodes.left && this.isActive) ||
				(e.keyCode === keyCodes.right && !this.isActive)
			) {
				this.onChange();
			}
		},
		switchHandler() {
			return {
				left: this.onSwipeLeft,
				right: this.onSwipeRight
			};
		},
		valueChanged(newValue) {
			if (this.reactive) {
				this.internalValue = newValue;
			}
		}
	},
	props: {
		value: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		id: { type: String, default: 'hokswitch', required: true },
		styling: {
			type: String,
			default: 'business',
			validator: (value: string) => ['main', 'business'].includes(value)
		},
		reactive: { type: Boolean, default: false }
	},
	watch: {
		value: [
			{
				handler: 'valueChanged'
			}
		]
	}
});
